import React from "react";
import { Item } from "semantic-ui-react";
import { Link } from "react-router-dom";
import moment from "moment";
import { motion } from "framer-motion";
import style from "./public.module.css";
import ForwardIcon from "../ForwardIcon/ForwardIcon";
// import DeleteIcon from "../DeleteIcon/DeleteIcon";
import MediaIcon from "../MediaIcon";

const list = {
  visible: { opacity: 1 },
  hidden: { opacity: 0 },
};

// const item = {
//   visible: { opacity: 1, x: 0 },
//   hidden: { opacity: 0, x: -100 },
// };

const PostsList = ({ posts, lightRed, lightGreen, memberPost }) => {
  return (
    <React.Fragment>
      <motion.ul initial="hidden" animate="visible" variants={list}>
        {posts.map((post, i) => (
          <motion.li
            key={i}
            whileHover={{ backgroundColor: "#eaeff2" }}
            style={{ backgroundColor: "#F5F8FA", borderRadius: 5, margin: 10 }}
          >
            <PostsListItem
              post={post}
              lightRed={lightRed}
              lightGreen={lightGreen}
              memberPost={memberPost}
            />
          </motion.li>
        ))}
      </motion.ul>
    </React.Fragment>
  );
};

export default PostsList;

const PostsListItem = ({ post, lightRed, lightGreen, memberPost }) => {
  const { _id, file, title, author, createdAt, place } = post;
  return (
    <div className={style.topbottompadding}>
      <Item.Group divided>
        <Item>
          <motion.div
            animate={{
              scale: [1, 1.2, 1.2, 1, 1],
            }}
          >
            <MediaIcon avatar file={file} title={title} />
          </motion.div>
          <Item.Content className="ml">
            <Item.Header as={Link} to={`/post/${_id}`} className="pt14">
              {title}
            </Item.Header>
            <ForwardIcon postId={_id} />
            <div
              className={style.togglefloat}
              style={{ display: "flex", flexDirection: "column" }}
            >
              {moment(new Date(parseInt(createdAt))).format("lll")}
              <p style={{ fontSize: "1.2rem" }}>
                {place.name} {place.state.name}
              </p>
              <p style={{ fontSize: "1.2rem" }}>Likes {post.likes}</p>
            </div>

            <Item.Description>
              <div style={{ marginTop: -10 }}></div>
            </Item.Description>

            <Item.Extra>
              <div>
                <p
                  className="mt20"
                  style={{ fontSize: "1.2rem", letterSpacing: 0.3 }}
                >
                  Published By :
                  <strong> {author?.name ? author.name : author.mobile}</strong>
                </p>
              </div>
            </Item.Extra>
          </Item.Content>
        </Item>
      </Item.Group>
    </div>
  );
};
